/**
 * Soul Hippy homepage hero tab slider
 * Autoplay every 5.5s; title/tab underlines shrink left / grow right on change.
 */
(function () {
  const TRANSITION_MS = 500;

  function initHero(root) {
    if (!root || root.dataset.shHeroReady) return;
    root.dataset.shHeroReady = 'true';

    const slides = Array.from(root.querySelectorAll('[data-sh-slide]'));
    const tabs = Array.from(root.querySelectorAll('[data-sh-tab]'));
    if (!slides.length || !tabs.length) return;

    let index = slides.findIndex((s) => s.classList.contains('is-active'));
    if (index < 0) index = 0;
    let timer = null;
    let transitioning = false;
    const INTERVAL = Number(root.dataset.interval) || 5500;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Ensure initial underline is painted full on the active slide/tab
    slides[index]?.classList.add('is-active');
    tabs[index]?.classList.add('is-active');

    function goTo(next) {
      if (transitioning) return;
      const nextIndex = (next + slides.length) % slides.length;
      if (nextIndex === index) {
        restartTimer();
        return;
      }

      const prevIndex = index;
      transitioning = true;

      const prevSlide = slides[prevIndex];
      const nextSlide = slides[nextIndex];
      const prevTab = tabs[prevIndex];
      const nextTab = tabs[nextIndex];

      // Outgoing: shrink underline to the left
      prevSlide.classList.add('is-leaving');
      prevSlide.classList.remove('is-active');
      prevSlide.setAttribute('aria-hidden', 'true');

      prevTab.classList.add('is-leaving');
      prevTab.classList.remove('is-active');
      prevTab.setAttribute('aria-selected', 'false');

      // Incoming: grow underline to the right (reflow so transition runs from 0)
      nextSlide.classList.remove('is-leaving');
      void nextSlide.offsetWidth;
      nextSlide.classList.add('is-active');
      nextSlide.setAttribute('aria-hidden', 'false');

      nextTab.classList.remove('is-leaving');
      void nextTab.offsetWidth;
      nextTab.classList.add('is-active');
      nextTab.setAttribute('aria-selected', 'true');

      index = nextIndex;

      const settle = () => {
        prevSlide.classList.remove('is-leaving');
        prevTab.classList.remove('is-leaving');
        transitioning = false;
        restartTimer();
      };

      if (reduceMotion) {
        settle();
        return;
      }

      window.setTimeout(settle, TRANSITION_MS);
    }

    function nextSlide() {
      goTo(index + 1);
    }

    function restartTimer() {
      clearTimeout(timer);
      if (reduceMotion) return;
      timer = setTimeout(nextSlide, INTERVAL);
    }

    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => goTo(i));
    });

    root.addEventListener('mouseenter', () => clearTimeout(timer));
    root.addEventListener('mouseleave', restartTimer);
    root.addEventListener('focusin', () => clearTimeout(timer));
    root.addEventListener('focusout', (e) => {
      if (!root.contains(e.relatedTarget)) restartTimer();
    });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) clearTimeout(timer);
      else restartTimer();
    });

    restartTimer();
  }

  function initAll(scope) {
    const root = scope || document;
    root.querySelectorAll('[data-sh-hero]').forEach((hero) => {
      delete hero.dataset.shHeroReady;
      initHero(hero);
    });
  }

  window.SoulHippyHero = { init: initAll, initHero };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const hero = event.target.querySelector?.('[data-sh-hero]') || event.target.closest?.('[data-sh-hero]');
    if (hero) {
      delete hero.dataset.shHeroReady;
      initHero(hero);
    } else {
      initAll(event.target);
    }
  });
})();
